(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VoucherProperties', VoucherProperties);

    VoucherProperties.$inject = ['$resource'];

    function VoucherProperties ($resource) {
        var service = $resource('api/property', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();
